// Frontend logger that can be toggled based on environment
const isDevelopment = process.env.NODE_ENV !== 'production';

const logger = {
  log: (...args) => isDevelopment && console.log(...args),
  info: (...args) => isDevelopment && console.info(...args),
  warn: (...args) => isDevelopment && console.warn(...args),
  error: (...args) => console.error(...args), // Always log errors
  debug: (...args) => isDevelopment && console.debug(...args)
};

export default logger;